import yn from "yn";

const { VITE_DATASETS_ENABLED } = import.meta.env;

const useDatasetsEnabled = (): boolean => {
  return yn(VITE_DATASETS_ENABLED, { default: false });
};

export default useDatasetsEnabled;
